// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"11":"5a4bfec0","92":"5bcff2b5","556":"8b994338","621":"aa6866a3"}[chunkId] + ".chunk.css";
};